module.exports = __webpack_public_path__ + "3a98261a1d6945dde356a0dfb03853fb.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/brandon.png
// module id = 589
// module chunks = 0